import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { ROUTES } from 'config/constants';
import AccountNav from 'components/AccountNav/AccountNav';

const MyProfileMenu = () => {
    const history = useHistory();
    const { profile, singPassVerified, singPassExpired } = useSelector((state) => ({
        profile: state.auth.profile,
        singPassVerified: state.auth?.profile?.singpass_status,
        singPassExpired: state.auth?.profile?.singpassExpired
    }));

    const [tabMenu, setTabMenu] = useState([
        {
            name: 'My Profile',
            type: ROUTES.MYINFORMATION,
            onClick: () => onClickTabButton(ROUTES.MYINFORMATION),
            isActive: false
        },
        {
            name: 'My Subscriptions',
            type: [ROUTES.SUBSCRIPTIONS, ROUTES.ORDEREDPRODUCTSINGLE, ROUTES.PRODUCTORDERSUMMARYSINGLE],
            onClick: () => onClickTabButton(ROUTES.SUBSCRIPTIONS),
            isActive: false
        },
        {
            name: 'Payment Info',
            type: ROUTES.PAYMENTINFO,
            onClick: () => onClickTabButton(ROUTES.PAYMENTINFO),
            isActive: false
        },
        {
            name: 'Shipping Details',
            type: ROUTES.SHIPPINGINFO,
            onClick: () => onClickTabButton(ROUTES.SHIPPINGINFO),
            isActive: false
        },
        {
            name: 'Refer and Earn',
            type: ROUTES.REFER_AND_EARN,
            onClick: () => onClickTabButton(ROUTES.REFER_AND_EARN),
            isActive: false
        }
    ]);

    const onClickTabButton = param => history.push(param);

    useEffect(() => {
        const currentPathname = history.location.pathname;
        const updatedTabMenu = tabMenu.map(tab => {
            return {
                ...tab,
                isActive: Array.isArray(tab.type) ? tab.type.some(path => currentPathname.includes(path)) : currentPathname === tab.type
            };
        });

        setTabMenu(updatedTabMenu);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history.location.pathname]);

    return (
        <AccountNav
            isSingPassVerified={!(!singPassVerified || singPassVerified === 'rejected')}
            singPassVerified={singPassVerified || ''}
            tabMenu={tabMenu}
            name={profile.name || ''}
            isSingPassExpired={singPassExpired} />
    );
};

MyProfileMenu.propTypes = {
    isSingPassVerified: PropTypes.bool
};

export default MyProfileMenu;
